import { svg } from "config/svgStyles";
import { merge } from "theme-ui";
export const modalContainer = ({ isMobile }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: isMobile ? "20px" : "20px",
  borderRadius: "40px",
});
export const displayImage = {
  display: "block",
  // objectFit: "cover",
  width: "80%",
  height: "50%",
  objectPosition: "center",
};
export const title = ({ isMobile }) => ({
  width: "100%",
  height: "100%",
  objectPosition: "center",
  textAlign: "center",
  fontSize: isMobile ? "20px" : "30px",
  fontWeight: "400",
  marginBottom: "40px",
});
export const step = ({ isMobile }) => ({
  width: "100%",
  height: "100%",
  objectPosition: "center",
  textAlign: "center",
  fontSize: isMobile ? "20px" : "30px",
  fontWeight: "700",
  letterSpacing: "0.2rem",
  lineHeight: "30px",
  marginTop: "20px",
  marginBottom: "10px",
});
export const detail = ({ isMobile }) => ({
  width: "100%",
  height: "100%",
  objectPosition: "center",
  textAlign: "center",
  fontSize: isMobile ? "40px" : "50px",
  fontWeight: "700",
  letterSpacing: "0.2rem",
  lineHeight: "50px",
  marginBottom: "10px",
});
export const description = ({ isMobile }) => ({
  width: "100%",
  height: "100%",
  objectPosition: "center",
  textAlign: "center",
  fontWeight: "400",
  fontSize: isMobile ? "14px" : "16px",
  lineHeight: "20px",
  marginBottom: "40px",
});
export const buttons = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "space-between",
};
export const skipButton = {
  background: "transparent",
  color: "#000",
  borderRadius: "28px",
  fontSize: "20px",
  fontWeight: "400",
};
export const nextButton = {
  background: "#000",
  color: "#fff",
  borderRadius: "28px",
  fontSize: "20px",
  fontWeight: "400",
};
export const paginationDots = {
  position: "absolute",
  bottom: "40px",
  left: 0,
  right: 0,
  display: "flex",
  justifyContent: "center",
  gap: "10px",
};
export const dots = {
  position: "relative",
  bottom: "-75px",
  background: "#fff",
  "& li": {
    background: "#fff",
    bottom: "50px",
  },
  "button-before": {
    background: "purple",
  },
};
export const closeButton = ({ isMobile }) =>
  merge(
    {
      color: "text",
      fontFamily: "body",
      fontWeight: "body",
      fontSize: "10px",
      lineHeight: "1",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      backgroundColor: "#000",
      svg: {
        marginLeft: isMobile ? "10px" : "0",
        width: "20px",
        ...svg("text"),
      },
      "&:hover, &:focus": {
        color: "primary",
        svg: {
          ...svg("primary"),
        },
      },
    },
    {
      margin: "0",
      position: "absolute",
      top: "0",
      right: "0",
      zIndex: 100,
      padding: "10px",
      borderRadius: "0 10px 0 20px",
    }
  );

export const customDotsContainer = ({ isMobile }) => ({
  backgroundColor: "transparent",
  borderRadius: "10px",
  padding: isMobile ? "0" : "10px",
  width: isMobile ? "50%" : "30%",
  marginBottom: "50px",
  marginLeft: isMobile ? "21%" : "33%",
  ul: {
    margin: 0,
    li: {
      button: {
        "&::before": {
          color: "#009CDA", // Change this to any color you want for the inactive dots
        },
        "&.active": {
          "&::before": {
            color: "#009CDA", // Change this to any color you want for the active dot
          },
        },
      },
    },
  },
});
